<template>
  <div class="xy-progress" ref="componentRef">
    <div class="xy-progress-box" :style="progressStyle">
      <div class="xy-progress-line" :style="progressLineStyle"></div>
    </div>
    <img v-if="props.stepSrc" class="xy-progress-step" :src="props.stepSrc" :style="stepStyle" alt="" />
  </div>
</template>

<script setup>
import { computed, onMounted, onUpdated, ref } from 'vue'
import { info, defaultProps } from './config'
import { computeRatioPx, computeRatio } from '@/packages/plugins/utils'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const componentRef = ref()
const language = ref('en')

// 进度百分比
const percentNumber = computed(() => {
  let percent = props.value / props.maxValue
  // 验证数据
  if (isNaN(percent) || percent < 0) {
    console.error('Invalid progress line data')
    percent = 0
  } else if (percent > 1) {
    percent = 1
  }
  return percent * 100
})

// 进度条样式
const progressStyle = computed(() => {
  return {
    borderRadius: computeRatioPx(props.borderRadius),
    backgroundColor: props.lineBackgroundColor,
    backgroundImage: `url('${props.lineBackgroundSrc}')`
  }
})

// 进度条线样式
const progressLineStyle = computed(() => {
  const style = {
    width: `${percentNumber.value}%`,
    backgroundColor: props.lineColor
  }
  if (props.lineSrc) {
    style.backgroundImage = `url('${props.lineSrc}')`
  }
  if (language.value === 'ar') {
    style.right = 0
  } else {
    style.left = 0
  }
  console.log('style', style)
  return style
})

// 进度条步骤样式
const stepStyle = computed(() => {
  const left = `calc(${percentNumber.value}% - ${computeRatio(props.stepSize) / 2}px)`
  const style = {
    width: computeRatioPx(props.stepSize),
    height: computeRatioPx(props.stepSize),
    top: computeRatioPx(props.stepTop)
  }
  if (language.value === 'ar') {
    style.right = left
  } else {
    style.left = left
  }
  return style
})

onMounted(() => {
  if (componentRef.value) {
    language.value = componentRef.value.getAttribute('language') || 'en'
  }
})
onUpdated(() => {
  if (componentRef.value) {
    language.value = componentRef.value.getAttribute('language') || 'en'
  }
})
</script>

<style lang="scss" scoped>
.xy-progress-box {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-size: cover; // 使背景图片铺满节点
  background-position: center; // 居中对齐背景图片
  background-repeat: no-repeat; // 防止背景图片重复
}
.xy-progress-line {
  width: 0px;
  height: 100%;
  position: absolute;
  top: 0;
  transition: width 1s;
  background-size: auto; // 按节点高度比例缩放背景图片
  background-position: left center; // 背景图片位置居左
  background-repeat: no-repeat; // 防止背景图片重复
}
.xy-progress-step {
  position: absolute;
  z-index: 2;
  object-fit: cover;
}
</style>
